<template>
  <Flatfinder class="project-mutate-flatfinders" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import Flatfinder from '@/components/Project/Flatfinder.vue'
import { i18n } from '@/i18n'

const meta = {
  order: 1003,
  id: 'flatfinders',
  label: i18n.tc('unitSelector', 2),
  icon: ['fal', 'layer-plus'],
}
export { meta }
export default {
  components: {
    Flatfinder,
  },
}
</script>

<style lang="scss"></style>
